import { Button } from '@flos/react-ui';
import CallMeModal from '../CallMeModal/CallMeModal';
import { useState } from 'react';
import { useHippoText } from '../../hooks/useHippoText';

const CallMeButton = ({
    buttonText,
    isFloating = true
}: {
    buttonText?: string;
    isFloating?: boolean;
}): React.JSX.Element => {
    const getHippoText = useHippoText();
    const [showModal, setShowModal] = useState(false);
    return (
        <>
            <div
                className={
                    isFloating
                        ? ' u-floating-cta u-spacing-stack-bottom-10 u-spacing-stack-bottom-none@xs'
                        : ''
                }
            >
                <Button
                    onClick={() => {
                        setShowModal(true);
                    }}
                    theme={isFloating ? 'float' : 'primary'}
                >
                    {buttonText ?? getHippoText('DSS-COMMON-CALL-ME')}
                </Button>
            </div>
            {showModal && (
                <CallMeModal
                    activityCode="dss_call_request"
                    showModal={showModal}
                    closeModal={() => {
                        setShowModal(false);
                    }}
                />
            )}
        </>
    );
};

export default CallMeButton;
